import { SVGProps, Ref, forwardRef } from 'react';

export const AstrostarOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.772 2.602C9.464 3.15 8.8 3.464 8.695 3.94a1 1 0 0 0 0 .45c.106.476.769.79 2.077 1.338.548 1.308.862 1.971 1.339 2.077.148.033.301.033.45 0 .476-.106.79-.769 1.338-2.077 1.309-.548 1.971-.862 2.078-1.339a1 1 0 0 0 0-.45c-.107-.476-.77-.79-2.078-1.339-.548-1.307-.862-1.97-1.339-2.076a1 1 0 0 0-.45 0c-.476.106-.79.769-1.338 2.077m2.586 1.836-.528.222-.222.528q-.155.37-.272.637a36 36 0 0 1-.273-.637l-.222-.528-.528-.222a36 36 0 0 1-.636-.272q.265-.12.636-.273l.528-.222.222-.528q.155-.37.273-.636.117.265.272.636l.222.528.528.222q.37.155.637.272-.265.118-.637.273"
                    fill="currentColor"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="m7.814 7.684-.25-.599C6.754 5.142 6.35 4.17 5.663 4.17S4.57 5.142 3.76 7.085l-.25.599-.598.25c-1.944.81-2.915 1.214-2.915 1.9 0 .688.971 1.093 2.915 1.902l.599.25.25.598c.81 1.944 1.214 2.916 1.9 2.916.688 0 1.093-.972 1.903-2.916l.249-.598.598-.25c1.944-.81 2.916-1.215 2.916-1.901 0-.687-.972-1.092-2.916-1.902zm-3.231 3.231-1.131-.47a47 47 0 0 1-1.423-.61c.356-.164.819-.358 1.423-.61l1.13-.47.472-1.131c.251-.604.445-1.067.609-1.423.163.356.357.819.61 1.423l.47 1.13 1.13.472a47 47 0 0 1 1.423.609c-.355.163-.818.357-1.422.61l-1.13.47-.472 1.13a47 47 0 0 1-.61 1.423 47 47 0 0 1-.608-1.422z"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
AstrostarOutlinedSize16Glyph.displayName = 'AstrostarOutlinedSize16Glyph';
